const basePagination = {
  size: 'small',
  position: [ 'bottomCenter' ],
  pageSizeOptions: [ '10', '25', '50' ],
  showSizeChanger: true,
};

export default basePagination;
